import { classNamesFor } from '../../../utils/classNames';

const factory = classNamesFor('FilterArea');

export const filterAreaClassNames = {
  root: factory.root(),
  toolbar: factory.element('toolbar'),
  summary: factory.element('summary'),
  resultCount: factory.element('resultCount'),
  filterCount: factory.element('filterCount'),
  divider: factory.element('divider'),
  chipsArea: factory.element('chipsArea'),
  clearButton: factory.element('clearButton'),
};
